<h1 mat-dialog-title>{{ data.name }}</h1>
<div mat-dialog-content>
  <p>{{ data.message }}</p>
</div>
<div mat-dialog-actions>
  @if (data.actions.includes('cancel')) {
    <button mat-button [mat-dialog-close]="false">Abbrechen</button>
  }
  @if (data.actions.includes('confirm')) {
    <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Bestätigen</button>
  }
</div>
